import React from 'react'
import {Virtuoso, VirtuosoHandle} from 'react-virtuoso'

export interface IWuVirtualScrollProps {
  containerHeight?: number
  list: unknown[]
  callback: (index: number, item: React.ReactNode) => React.JSX.Element
  dir?: 'rtl' | 'ltr'
  className?: string
  style?: React.CSSProperties
}

export const WuVirtualScroll = React.forwardRef<
  VirtuosoHandle,
  IWuVirtualScrollProps
>(({containerHeight = 400, list, callback, dir, className, style}, ref) => {
  return (
    <Virtuoso
      ref={ref}
      dir={dir}
      style={{
        height: containerHeight,
        scrollbarWidth: 'thin',
        scrollbarColor: '#d4d4d4 #f1f1f1',
        overflowX: 'hidden',
        ...style,
      }}
      className={className}
      data={list}
      itemContent={(index, item) => callback(index, item as React.ReactNode)}
    />
  )
})

WuVirtualScroll.displayName = 'WuVirtualScroll'
